module.exports = __webpack_public_path__ + "assets-cabinet/img/user-ico.52b85c5e.svg";